import * as T from "../../utilities/frontendTypes";
import { apiGet, apiPut } from "../apiClient";

// Feature Flags

export async function getFeatureFlags(): Promise<T.FeatureFlagsResponse> {
  return apiGet<T.FeatureFlagsResponse>("/api/admins/feature-flags");
}

export async function updateFeatureFlags(flags: Record<string, boolean>): Promise<T.FeatureFlagsResponse> {
  return apiPut<T.FeatureFlagsResponse>("/api/admins/feature-flags", { flags });
}
